import * as React from 'react';

export const UserAgentContext = React.createContext<string>('');
export const UserAgentProvider = UserAgentContext.Provider;
export const useUserAgent = () => React.useContext(UserAgentContext);
